import { useCurrentUser } from '@hotjar/user';

export function useIsDemoUser(): boolean {
  const { data: user } = useCurrentUser();

  return user?.isDemoUser ?? false;
}
